// extracted by mini-css-extract-plugin
export default {"list":"NotificationsComponent_list__sU+fZ","description":"NotificationsComponent_description__QMnl2"};